import { GetServerSideProps } from 'next'

import IndividualPreconPage from '@/pages/precon/[precon]'
import { serverSidePropsFor } from '@/utils/helpers.server'

export const getServerSideProps: GetServerSideProps = async ({ query, req }) =>
  serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/precon/${query.precon}/${query.commander}.json`,
    req.headers,
  )

export default IndividualPreconPage
